import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { GmapsProvider } from 'providers/gmaps/gmaps';
import { GeolocalizationProvider } from 'providers/geolocalization/geolocalization';
import { DomainStorageProvider } from 'providers/domain-storage/domain-storage';
import { fadeInAnimation } from 'animations';
import * as _ from "lodash";

@Component({
    selector: 'app-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.scss'],

    animations: [fadeInAnimation],
})
export class AutocompleteComponent implements OnInit {

    isInputFocus: boolean = false;
    showSearchResults: boolean = false;
    isLoading: boolean = false;
    searchResults: any = [];
    searchTimer: any = null;

    @Output("search-result-click") searchResultClick = new EventEmitter<any>();
    @Output("my-location-click") myLocationClick = new EventEmitter<any>();
    @Output("choose-from-map-click") chooseFromMapClick = new EventEmitter<any>();
    @Output("input-focus") onInputFocus = new EventEmitter<any>();

    constructor(
        public gmaps: GmapsProvider,
        public geolocalizationProvider: GeolocalizationProvider,
        private domainStorageProvider: DomainStorageProvider,
    ) {


    }

    ngOnInit() {
    }

    onInputReset($event) {
        this.showSearchResults = false;
        this.isInputFocus = true;
    }

    onChooseFromMapClick($event) {
        this.onInputFocusOut($event);
        this.chooseFromMapClick.emit();
    }

    onInputFocusIn($event) {
        this.onInputFocus.emit();
        this.onInputFocusOut($event)
        this.isInputFocus = true;
        this.onInputChange($event);
    }

    onInputFocusOut($event) {
        this.isInputFocus = false;
    }

    onSearchResultClick(item) {
        this.searchResultClick.emit(item);
        this.showSearchResults = false;
        this.isInputFocus = false;
    };

    onMyLocationClick() {
        this.myLocationClick.emit();
        this.showSearchResults = false;
        this.isInputFocus = false;
    }

    async onInputChange($event) {

        let query = $event && $event.target ? $event.target.value : null;

        this.isLoading = false;

        if (this.searchTimer) {
            clearInterval(this.searchTimer);
        }
        if (query != null && query.length > 2) {
            this.isInputFocus = false;
            this.showSearchResults = true;
            this.isLoading = true;
            this.searchTimer = _.delay(async () => {

                try {
                    let results = await this.gmaps.searchPlaces($event.target.value);
                    this.searchResults = _.take(results, 5);
                }
                catch (e) {
                    console.log(e);
                }

                this.isLoading = false;
            }, 300);
        }
        else {
            this.searchResults = [];
            this.showSearchResults = false;
            this.isInputFocus = true;
        }
    }
}
